import app from 'flarum/forum/app';
let nextId = 0;

/**
 * Manages the queue of realtime notification toasts.
 * Each toast auto-dismisses after the configured flarum-realtime.notification-toast-dismiss-after seconds.
 */
export default class NotificationToastState {
  toasts = [];
  all() {
    return this.toasts;
  }
  push(notification) {
    const settings = app.data?.settings ?? {};
    const dismissAfterS = settings['flarum-realtime.notification-toast-dismiss-after'] ?? 10;
    if (dismissAfterS === 0) return;
    const id = nextId++;
    this.toasts.push({
      id,
      notification
    });
    m.redraw();
    setTimeout(() => this.dismiss(id), dismissAfterS * 1000);
  }
  dismiss(id) {
    const index = this.toasts.findIndex(t => t.id === id);
    if (index !== -1) {
      this.toasts.splice(index, 1);
      m.redraw();
    }
  }
}
flarum.reg.add('flarum-realtime', 'forum/states/NotificationToastState', NotificationToastState);